import React from 'react';
import { Form} from 'semantic-ui-react';
import countryOptions from "../options/countryOptions";

class CountryDropdown extends React.Component {
  shouldComponentUpdate(nextProps, nextState){
    if(nextProps.value !== this.props.value || nextProps.disabled !== this.props.disabled){
      return true
    }
    return false
  }
  render(){
    return (
      <Form.Dropdown
        selection
        search
        options={countryOptions}
        {... this.props}
      />
    )
  }

}

export default CountryDropdown



// WEBPACK FOOTER //
// ./src/component/CountryDropdown.js